module.exports = __webpack_public_path__ + "img/dj.423c4156.svg";